var React = require('react');

function OutlineCircles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M236.5 118C236.5 182.891 183.672 235.5 118.5 235.5C53.3284 235.5 0.5 182.891 0.5 118C0.5 53.1085 53.3284 0.5 118.5 0.5C183.672 0.5 236.5 53.1085 236.5 118Z","stroke":"#4F9B0B","strokeOpacity":"0.23","key":0}),React.createElement("path",{"d":"M201.5 118C201.5 163.561 164.342 200.5 118.5 200.5C72.6575 200.5 35.5 163.561 35.5 118C35.5 72.4393 72.6575 35.5 118.5 35.5C164.342 35.5 201.5 72.4393 201.5 118Z","stroke":"#4F9B0B","strokeOpacity":"0.23","key":1})]);
}

OutlineCircles.defaultProps = {"width":"237","height":"236","viewBox":"0 0 237 236","fill":"none"};

module.exports = OutlineCircles;

OutlineCircles.default = OutlineCircles;
